module.exports = __webpack_public_path__ + "img/logo-dark.43a56669.svg";